module.exports = __webpack_public_path__ + "prod/20260417190217/img/url-app.d88da72d.png";